import { render, staticRenderFns } from "./CelemonyPrint.vue?vue&type=template&id=2270aba7&scoped=true&"
import script from "./CelemonyPrint.vue?vue&type=script&lang=js&"
export * from "./CelemonyPrint.vue?vue&type=script&lang=js&"
import style0 from "./CelemonyPrint.vue?vue&type=style&index=0&id=2270aba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270aba7",
  null
  
)

export default component.exports